import QuestionWrite from '../QuestionWrite/QuestionWrite';
import QuestionText from '../QuestionText/QuestionText';
import QuestionMultipleChoice from '../QuestionMultipleChoice/QuestionMultipleChoice';
import QuestionWithVideoAnswer from '../QuestionWithVideoAnswer/QuestionWithVideoAnswer';
import QuestionWithFiles from '../QuestionWithFiles/QuestionWithFiles';
import QuestionCode from '../QuestionCode/QuestionCode';
import QuestionDraw from '../QuestionDraw/QuestionDraw';
import { AnswerTypeEnum } from '../../constants/enums';
import QuestionChallenge from '../QuestionChallenge/QuestionChallenge';

const QuestionComponentSelector = ({
  currentTypeQuestion,
  testGroupABM,
  readOnly,
  ...otherProps
}) => {
  if ([AnswerTypeEnum.WRITE].includes(currentTypeQuestion)) {
    return <QuestionWrite testGroupABM={testGroupABM} readOnly={readOnly} {...otherProps} />;
  }
  if ([AnswerTypeEnum.CHALLENGE_ASYNC_AI].includes(currentTypeQuestion)) {
    return (
      <QuestionChallenge
        currentTypeQuestion={currentTypeQuestion}
        testGroupABM={testGroupABM}
        readOnly={readOnly}
        {...otherProps}
      />
    );
  }
  if ([AnswerTypeEnum.TEXT, AnswerTypeEnum.TEXT_AI].includes(currentTypeQuestion)) {
    return <QuestionText testGroupABM={testGroupABM} readOnly={readOnly} {...otherProps} />;
  }
  if ([AnswerTypeEnum.CHECK, AnswerTypeEnum.RADIO].includes(currentTypeQuestion)) {
    return (
      <QuestionMultipleChoice testGroupABM={testGroupABM} readOnly={readOnly} {...otherProps} />
    );
  }
  if ([AnswerTypeEnum.VIDEO, AnswerTypeEnum.VIDEO_AI].includes(currentTypeQuestion)) {
    return (
      <QuestionWithVideoAnswer testGroupABM={testGroupABM} readOnly={readOnly} {...otherProps} />
    );
  }
  if ([AnswerTypeEnum.FILE].includes(currentTypeQuestion)) {
    return <QuestionWithFiles testGroupABM={testGroupABM} readOnly={readOnly} {...otherProps} />;
  }
  if ([AnswerTypeEnum.CODE, AnswerTypeEnum.CODE_AI].includes(currentTypeQuestion)) {
    return <QuestionCode testGroupABM={testGroupABM} readOnly={readOnly} {...otherProps} />;
  }
  if ([AnswerTypeEnum.DRAW].includes(currentTypeQuestion)) {
    return <QuestionDraw readOnly={readOnly} />;
  }

  return null;
};

export default QuestionComponentSelector;
